/* eslint-disable import/prefer-default-export */

import { debounce } from 'lodash';

export const useDebounce = DEBOUNCED_DELAY => {
  const applyDebounce = debounce(func => {
    func();
  }, DEBOUNCED_DELAY);

  return {
    applyDebounce,
  };
};
